import partial from 'transmute/partial';
import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
const UPLOAD_PERCENT = 90;
const PROGRESSION_PERCENT_FACTOR = (100 - UPLOAD_PERCENT) / 10;
const baseUrl = 'presentations/v1/deck';
const getProgressionPercentage = percentage => percentage * PROGRESSION_PERCENT_FACTOR + UPLOAD_PERCENT;
const _checkStatus = progressionId => {
  return http.get(`${baseUrl}/upload/progressions`, {
    query: {
      progressionId
    }
  }).then(fromJS);
};
const onCheckStatus = ({
  onProgress,
  resolve,
  reject,
  clearUploadInterval
}, results) => {
  if (results.isEmpty()) {
    return null;
  }
  const progressionData = results.first();
  const state = progressionData.getIn(['progression', 'state']);
  const percentage = progressionData.get('percentage');
  const progressionPercentage = getProgressionPercentage(percentage);
  switch (state) {
    case 'ERROR':
      clearUploadInterval();
      return reject();
    case 'UPLOADED':
      {
        clearUploadInterval();
        return resolve(progressionData.get('deck'));
      }
    default:
      return onProgress(progressionPercentage);
  }
};
export const uploadProgressionData = (initialProgressionData, onProgress) => {
  let uploadInterval;
  return new Promise((resolve, reject) => {
    const progressionId = initialProgressionData.getIn(['progression', 'id']);
    const clearUploadInterval = () => clearInterval(uploadInterval);
    uploadInterval = setInterval(() => _checkStatus(progressionId).then(partial(onCheckStatus, {
      clearUploadInterval,
      onProgress,
      resolve,
      reject
    })).catch(error => {
      clearUploadInterval();
      reject(error);
    }), 1000);
  });
};
export const uploadFile = ({
  file,
  deckId,
  folderId,
  brandId,
  onProgress
}) => {
  const formData = new FormData();
  formData.append('file', file);
  const onUploadProgress = ({
    loaded,
    total
  }) => {
    const uploadPercent = loaded / total * UPLOAD_PERCENT;
    onProgress(uploadPercent);
  };
  return http.post(`${baseUrl}/upload`, {
    timeout: 0,
    headers: {
      'content-type': false
    },
    data: formData,
    query: Object.assign({
      deckId,
      folderId
    }, brandId !== undefined && {
      brandId
    }),
    withXhr: xhr => {
      xhr.upload.addEventListener('progress', onUploadProgress, false);
    }
  }).then(fromJS);
};
export const importFile = ({
  type,
  deckId,
  folderId,
  brandId,
  fileManagerFileId,
  file: {
    name,
    link,
    accessToken = ''
  }
}) => {
  return http.post(`${baseUrl}/import`, {
    query: Object.assign({
      deckId,
      folderId
    }, brandId !== undefined && {
      brandId
    }),
    data: {
      type,
      fileManagerFileId,
      file_name: name,
      deck_link: link,
      access_token: accessToken
    }
  }).then(fromJS);
};